'use client';

import type { PropsWithChildren } from 'react';

import { withPromo } from '@/helpers/hocs';

function Template({ children }: PropsWithChildren) {
  return children;
}

export default withPromo(Template, {
  redirectUrl: '/',
  promoName: 'mission',
});
